import { Box } from '@bechtel/gds';
import { MultiLingualText } from '~/components';
//@ts-ignore images ignore
import { ReactComponent as UnderConstructionIcon } from '~/images/under-construction.svg';
import { UnderConstructionStyled } from './styled';

export const UnderConstruction = () => {
  return (
    <Box
      flexDirection={{ sm: 'column' }}
      justifyContent={{ sm: 'center' }}
      alignItems={{ sm: 'center' }}
      css={{ height: '100%' }}
    >
      <UnderConstructionStyled>
        <UnderConstructionIcon />
      </UnderConstructionStyled>
      <Box mt={{ sm: '300' }} mb={{ sm: '200' }}>
        <MultiLingualText size="400" color="grey.600" weight="600">
          This module is under construction.
        </MultiLingualText>
      </Box>
      <MultiLingualText size="300" color="grey.600" weight="400">
        Please check back later.
      </MultiLingualText>
    </Box>
  );
};
